import React, { useState } from 'react'
import Box from '@material-ui/core/Box'
import bannerImg from '../../assets/images/general_banner_img.png'
import { Button } from '../../components/Button'
import { Grid } from '../../components/layout/Grid'
import { updateSimpleRiskUsingHandler } from './RiskHelper'
import { ConfirmationDialog } from '../../components/Dialog'
import { valueToRiskBracket } from '@utils/riskConversions'
import { Slider } from '@components/Slider'

export const SimpleRisk = (props) => {
  const [riskRatingSliderValue, setRiskRatingSliderValue] = useState(props.riskProfile.rating)
  const [confirmationDialog, setConfirmationDialog] = useState(false)

  return (
    confirmationDialog
      ? <SimpleRiskConfirmationDialog
        {...props}
        riskRatingSliderValue={riskRatingSliderValue}
        setConfirmationDialog={setConfirmationDialog}
      />
      : <SimpleRiskForm
        {...props}
        riskRatingSliderValue={riskRatingSliderValue}
        setRiskRatingSliderValue={setRiskRatingSliderValue}
        setConfirmationDialog={setConfirmationDialog} />
  )
}

export const SimpleRiskForm = (props) =>
  <Grid halfSplit>
    <SimpleRiskSlider
      key='simple-risk-slider'
      {...props}
      riskRatingSliderValue={props.riskRatingSliderValue}
      setRiskRatingSliderValue={props.setRiskRatingSliderValue}
      setConfirmationDialog={props.setConfirmationDialog}
    />
    <SimpleRiskInfo />
  </Grid>

export const SimpleRiskSlider = ({ riskProfile, riskRatingSliderValue, setRiskRatingSliderValue, setConfirmationDialog, inflation }) => {
  return (
    <div className='scenario-planning__slider'>
      <Box className='app-slider' width='100%'>
        <h5>Risk Profile</h5>
        <label style={{ textAlign: 'left' }}>{valueToRiskBracket(riskProfile.rating)} -  Return goal:  {(inflation * 100) + riskProfile.rating}%</label>
        <Box display='flex' justifyContent='space-between'>
          <p className="mb-0">{valueToRiskBracket(1)}</p>
          <p className="mb-0">{valueToRiskBracket(5)}</p>
        </Box>
        <Slider
          onChange={(_e, value) => setRiskRatingSliderValue(value)}
          value={riskRatingSliderValue}
          defaultValue={riskProfile.rating}
          min={1.0}
          max={5.0}
          step={1}
        />
        <Box display='flex' justifyContent='center'>
          <label>{valueToRiskBracket(riskRatingSliderValue)} -  Return goal:  {(inflation * 100) + riskRatingSliderValue}%</label>
        </Box>
      </Box>
      <Button
        primary
        onClick={() => setConfirmationDialog(true)}
        data-tracking='true'
        data-event-name='Scenario planning: Use simple risk' >{ `UPDATE & USE SIMPLE RISK` }</Button>
    </div>
  )
}

export const SimpleRiskInfo = () =>
  <div className='info-section'>
    <h3>Add your <b>Risk</b> information here.</h3>
    <img src={bannerImg} />
  </div>

export const SimpleRiskConfirmationDialog = (props) => {
  const [loading, setLoading] = useState(false)
  return (
    <ConfirmationDialog
      heading={`Are you sure you want to override your risk rating?`}
      subheading={`Changing the risk rating directly affects your projections`}
      primaryButton={() =>
        <Button
          disabled={loading} primary
          onClick={updateSimpleRisk(props, setLoading)}>
          {loading ? 'Updating risk profile...' : `YES I'M SURE`}
        </Button>}
      secondaryButton={() => <Button disabled={loading} secondary onClick={goBack(props)}>{`NOT RIGHT NOW`}</Button>} />
  )
}

const updateSimpleRisk = (props, setLoading) => async () => {
  setLoading(true)
  try {
    await updateSimpleRiskUsingHandler(
      props.updateRiskHandler,
      props.riskRatingSliderValue,
      props.riskProfile,
      props.isWealthManager,
      props.crudActions,
      props.saygScenariosEnabled
    )
    props.setConfirmationDialog(false)
  } finally {
    setLoading(false)
  }
}

const goBack = (props) => () =>
  props.setConfirmationDialog(false)
